import {
  faHome,
  faUserGroup,
  faCalendarDays,
  faHeadset,
  faClockRotateLeft,
  faPeopleGroup,
  faPalette,
  faCircleInfo,
} from '@fortawesome/free-solid-svg-icons';

// Menu Component constants starts

export const NAVIGATION_MENU = [
  {
    HEADING: 'Home',
    ICON: faHome,
    NAVIGATION: '/home',
  },
  {
    HEADING: 'About',
    ICON: faCircleInfo,
    NAVIGATION: '/about',
  },
  {
    HEADING: 'Guests',
    ICON: faUserGroup,
    NAVIGATION: '/guests',
  },
  {
    HEADING: 'Schedule',
    ICON: faCalendarDays,
    NAVIGATION: '/schedule',
  },
  {
    HEADING: 'Speakers',
    ICON: faHeadset,
    NAVIGATION: '/speakers',
  },
  {
    HEADING: 'Recap',
    ICON: faClockRotateLeft,
    NAVIGATION: '/recap',
  },
  {
    HEADING: 'Committee',
    ICON: faPeopleGroup,
    NAVIGATION: '/committee',
  },
];

export const THEMECONSTANTS = {
  HEADING: 'Theme',
  ICON: faPalette,
};

// Menu Component constants ends

export const SCHEDULE_ROUTE = '/schedule';

export const HOME_ROUTE = '/home';
export const FULL_SCREEN = ['/', '/scanner', '/screenSaver', '/screensaver', '/scan', '/runtime', '/runTime'];
